
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M89.4 7.1C36.7 24 .9 73.1.9 128.5c0 7.7.7 15.2 2 22.6v.2l.6 2.7c11.9 58 63.1 101.7 124.6 101.7 70.4.1 127.4-56.9 127.5-127.2C255.7 58.2 198.7 1.1 128.4 1c-1.9 0-3.7 0-5.5.1","fill":"#fff"}}),_c('path',{attrs:{"d":"M253 102.7C241.1 44.7 189.9 1 128.4 1 58 .9 1 57.9.9 128.2s56.9 127.4 127.2 127.5c1.9 0 3.7 0 5.5-.1v-81.3h-27.9v-32.4h27.9v-23.8c0-27.7 16.9-42.8 41.6-42.8 8.3 0 16.6.4 24.9 1.3v28.9h-17c-11.8 0-15.2 4.9-15.9 12.3-.1 1-.1 2-.1 3.1v21h32l-4.2 32.4h-27.8v75.3c52.7-16.9 88.5-66 88.5-121.4 0-7.7-.7-15.2-2-22.6v-.2l-.6-2.7z"}})])
          )
        }
      }
    